import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from './config.model';
import { catchError, lastValueFrom, Observable, of } from 'rxjs';

@Injectable()
export class ConfigLoaderService {

  settings: AppConfiguration;

  constructor(private httpClient: HttpClient) { }

  loadSettings(): Promise<AppConfiguration> {
    const targetConfigFile = 'assets/config/config.json';
    return lastValueFrom(this.httpClient.get<AppConfiguration>(targetConfigFile)).then((settings: AppConfiguration) => {
      this.settings = settings;
      console.log('Loaded configfile: ' + targetConfigFile);
      console.log('Settings are: ', settings);
      return settings;
    }).catch((error) => {
      console.log('Error loading configfile: ' + targetConfigFile);
      console.log('Error message: ', error);
      return null;
    });
  }

  getSettings(): AppConfiguration {
    if (!this.settings) {
      throw new Error('Settings not loaded');
    }
    return this.settings;
  }

  getTurnServerToken(): Observable<object> {
    const targetUrl = `${this.settings.pyWallServer.url}vtr/turnservertoken/`;
    return this.httpClient.get<object>(targetUrl).pipe(catchError(error => {
      console.error('Error retrieving turn-server-token from awall: ', error);
      return of(null);
    }));
  }

  getSpeechServerToken(): Observable<{token: string; region: string}> {
    const targetUrl = `${this.settings.pyWallServer.url}speech-token`;
    return this.httpClient.get<{token: string; region: string}>(targetUrl).pipe(catchError(error => {
      console.error('Error retreiving speech server token from awall copilot: ', error);
      return of(null);
    }));
  }

}
